import script from "./MCVCDirector.vue?vue&type=script&setup=true&lang=js"
export * from "./MCVCDirector.vue?vue&type=script&setup=true&lang=js"

import "./MCVCDirector.vue?vue&type=style&index=0&id=38dda66e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38dda66e"]])

export default __exports__